/**
 * Hybrid Router Module
 *
 * This module configures @uirouter/angular-hybrid to allow both AngularJS
 * and Angular routes to coexist during the migration period.
 *
 * How it works:
 * 1. UI-Router's core is shared between AngularJS and Angular
 * 2. AngularJS states continue to work as before
 * 3. New Angular states can be added alongside existing ones
 * 4. Routes can be migrated one at a time
 *
 * Usage:
 * - Import this module in AppModule
 * - Define Angular routes using UIRouterModule.forChild() in feature modules
 * - AngularJS routes continue to work via $stateProvider
 *
 * IMPORTANT: Only use UIRouterUpgradeModule.forRoot() here.
 * Do NOT use UIRouterModule.forRoot() - the hybrid module handles root setup.
 * Feature modules should use UIRouterModule.forChild() to register their states.
 */
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

@NgModule({
  imports: [
    // UIRouterUpgradeModule.forRoot() sets up the hybrid router
    // This connects Angular's router to the existing AngularJS UI-Router
    // Do NOT add UIRouterModule.forRoot() - it conflicts with the hybrid setup
    UIRouterUpgradeModule.forRoot(),
  ],
  exports: [UIRouterModule],
})
export class HybridRouterModule {}

